import React, { Fragment, useEffect, useMemo, useState } from "react";

import ReactTable from "components/ReactTable/ReactTable.js";
import Button from "components/CustomButtons/Button.js";

import { Add } from "@material-ui/icons";

import { wsFindBy } from "services/WService";

const providerTableColumns = [
  { Header: "#", accessor: "num", excelEnabled: false },
  { Header: "Código", accessor: "code", width: 110 },
  { Header: "Nombre proveedor", accessor: "name" },
  { Header: "Agregar", accessor: "actions", excelEnabled: false }
];

export default function Provider(props) {
  const [providers, setProviders] = useState([]);
  const [warehouses, setWarehouses] = useState([]);

  const statePromo =
    props.promo.state == "N" || props.promo.state == "G" ? false : true;

  async function listProvider() {
    let response = await wsFindBy("prom/promotion/group-stock/provider", { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) {
      setProviders(response.data.providers);
      setWarehouses(response.data.warehouses);
    }
  }

  useEffect(() => {
    listProvider();
  }, []);

  const columns = useMemo(() => {
    if(warehouses.length === 0) return providerTableColumns;

    let columns = [];
    let index = providerTableColumns.findIndex((item) => item.accessor === 'name');
    for (let i = 0; i <= index; i++) {
      columns.push(providerTableColumns[i]);
    }
    for(let warehouse of warehouses){
      columns.push({
        Header: warehouse.WhsName.replace('Almacén', ''),
        accessor: `WHS-${warehouse.id}`,
        width: 85,
      });
    }
    for (let i = index + 1; i < providerTableColumns.length; i++) {
      columns.push(providerTableColumns[i]);
    }
    return columns;
  }, [warehouses]);

  return (
    <Fragment>
      <ReactTable
        exportExcel={false}
        heightRow={50}
        columns={columns}
        data={providers.map((provider, i) => {
          let dataStocks = {};
          for (let stock of provider.stocks) {
            dataStocks[`WHS-${stock.logi_warehouse_id}`] =
              parseFloat(stock.OnHand) - parseFloat(stock.IsCommited);
          }
          return {
            num: i + 1,
            code: provider.CardCode,
            name: provider.CardName,
            ...dataStocks,
            actions: (
              <div className="actions-right">
                <Button
                  justIcon
                  color="success"
                  className="like"
                  size="sm"
                  round
                  onClick={() => {
                    props.addProduct(provider);
                  }}
                  disabled={statePromo}
                >
                  <Add />
                </Button>
              </div>
            )
          };
        })}
      />
    </Fragment>
  );
}
